import { createSelector, createSlice } from '@reduxjs/toolkit';

const skillsSlice = createSlice({
    initialState: {
        cities: [],
        industries: {},
        subSkills: [],
        isLoading: false,
    },
    name: 'skills',
    reducers: {
        fetchSkills: state => {
            state.cities = [];
            state.industries = {};
            state.isLoading = true;
        },
        skillsFetched: (state, { payload }) => {
            const { cities, industries } = payload;
            state.cities = cities;
            state.industries = industries;
            state.isLoading = false;
        },
        skillsFetchRequestFailed: state => {
            state.isLoading = false;
        },
        fetchSubSkills: state => {
            state.subSkills = [];
            state.isLoading = true;
        },
        subSkillsFetched: (state, { payload }) => {
            state.subSkills = payload;
            state.isLoading = false;
        },
        subSkillsFetchRequestFailed: state => {
            state.isLoading = false;
        },
    },
});

// selectors
const getSelf = state => state.skills;

export const getSkills = createSelector(getSelf, state => {
    const skills = [];
    if (state.industries) {
        for (const industry in state.industries) {
            for (const skill in state.industries[industry]) {
                skills.push(state.industries[industry][skill]);
            }
        }
    }
    return skills;
});

export const getSubSkills = createSelector(getSelf, state => state.subSkills);

export const isLoading = createSelector(getSelf, state => state.isLoading);

export const {
    fetchSkills,
    skillsFetched,
    skillsFetchRequestFailed,
    fetchSubSkills,
    subSkillsFetched,
    subSkillsFetchRequestFailed,
} = skillsSlice.actions;

export default skillsSlice.reducer;
